export default {
  getAllSports: (state) => state.allSports,
  getAllFirstLetters: (state) => state.allFirstLetters,
  getSocialNetworks: (state) => state.socialNetworks
}
